import React, { useEffect, useRef } from "react";

import { Close } from "@mui/icons-material";
import { Menu, MenuItem, IconButton, Box, Button, useTheme } from "@mui/material";

import Loader from "../components/Loading";

const Notifications = ({ state, onClose, onLoadMoreNotifications }) => {
  const { anchorEl, data, loading } = state;
  const { content: notifications, totalElements } = data;
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const popupRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (evt) => {
      if (popupRef.current && !popupRef.current.contains(evt.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", onClickOutside);

    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [onClose]);

  return (
    <Menu
      {...{ anchorEl, onClose }}
      open={!!anchorEl}
      sx={{
        "& .MuiPaper-root": {
          padding: "1rem",
          position: "absolute",
          top: "3.5em !important",
          right: "0 !important",
          left: "unset !important",
          width: "350px",
          minHeight: "calc(100dvh - 3.5em)",
          borderRadius: 0,
          boxShadow: "none",
          background: isDarkMode ? "#1e293b" : "#fff",
          borderLeft: isDarkMode ? "1px solid #334155" : "1px solid rgba(0, 0, 0, 0.12)",
        },
        "& .MuiList-root": {
          padding: 0,
        },
      }}
      ref={popupRef}
    >
      <MenuItem
        disableRipple
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: 0,
          justifyContent: "center",
          "&:hover": { opacity: 1, background: "transparent", cursor: "auto" },
        }}
      >
        {/* Dismiss notifications */}
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            marginBottom: "0.5rem",
          }}
        >
          <h2 style={{ display: "flex", fontWeight: 600, color: isDarkMode ? "#f1f5f9" : "#333" }}>Notifications</h2>
          <IconButton
            size="small"
            onClick={() => {
              onClose();
            }}
            sx={{ marginLeft: "auto", color: isDarkMode ? "#94a3b8" : "inherit" }}
          >
            <Close />
          </IconButton>
        </Box>

        {notifications?.length === 0 ? (
          <sub style={{ color: isDarkMode ? "#94a3b8" : "#666" }}>No Notifications</sub>
        ) : (
          notifications?.map((notification) => {
            const titleElem = (
              <span
                style={{
                  fontSize: "0.9rem",
                  color: isDarkMode ? "#f1f5f9" : "#333",
                  display: "block",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {notification.title}
              </span>
            );
            return (
              <Box
                key={notification.id}
                sx={{
                  width: "100%",
                  marginTop: "0.2rem",
                  borderRadius: "8px",
                  border: isDarkMode ? "1px solid #334155" : "1px solid rgba(0, 0, 0, 0.12)",
                  background: isDarkMode ? "rgba(255,255,255,0.03)" : "transparent",
                  padding: "0.5rem",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                }}
              >
                {!notification.isRead ? (
                  <span
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 10px",
                      gap: "0.2rem",
                    }}
                  >
                    {titleElem}
                    <span
                      style={{
                        display: "flex",
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        background: "#F97316",
                      }}
                    ></span>
                  </span>
                ) : (
                  titleElem
                )}
                <span
                  style={{
                    display: "flex",
                    fontSize: "0.7rem",
                    color: isDarkMode ? "#64748b" : "#888",
                  }}
                >
                  {`Created: ${new Date(
                    notification.createdOn
                  ).toLocaleString()}`}
                </span>
              </Box>
            );
          })
        )}

        {/* Pagination */}
        {notifications?.length < totalElements && (
          <Button
            variant="text"
            onClick={onLoadMoreNotifications}
            sx={{
              color: "#EA580C",
              margin: "1rem 0",
              fontSize: "14px",
              textTransform: "none",
            }}
          >
            {loading ? <Loader specificDetails={{ size: 24 }} /> : "Load More"}
          </Button>
        )}
      </MenuItem>
    </Menu>
  );
};

export default Notifications;
